import styled from 'styled-components';
import { palette } from 'styled-theme';
import AppBar from '../../components/uielements/appbar';
import Toolbars from '../../components/uielements/toolbar';
import { boxShadow } from '../../settings/style-util';

const Toolbar = styled(Toolbars)`
  @media only screen and (max-width: 768px) {
    padding: 0 17px !important;
  }
`;

const AppHolder = styled(AppBar)`
  position: fixed;
  z-index: 1300;
  width: 100%;
  height: 65px;
  background-color: ${palette('indigo', 5)};
  transition: all 0.2s ease-in-out;
  ${boxShadow('0 1px 2px rgba(0,0,0,0.35)')};
`;

const LogoWrapper = styled.div`
  height: 64px;
  display:flex;
  align-items: center;
  img {
    max-height: 100%;
    max-width: 70%;
    display: block;
  }
`;


export { AppHolder, Toolbar, LogoWrapper };



// WEBPACK FOOTER //
// ./src/containers/TopbarNoAuth/style.js